module.exports = __webpack_public_path__ + "img/rysBg.24c28530.png";